import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-lg border-2 px-3 py-1.5 text-xs font-bold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-[#00f4ff] focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-gradient-to-r from-[#00f4ff] to-[#12b7ff] text-[#040816] shadow-lg shadow-[#00f4ff]/30 hover:shadow-xl hover:shadow-[#00f4ff]/50 hover:scale-105",
        secondary:
          "border-[#9EB4C0]/30 bg-[#0b1c38]/50 text-[#9EB4C0] backdrop-blur-sm hover:bg-[#0b1c38] hover:border-[#9EB4C0]/50",
        destructive:
          "border-transparent bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg shadow-red-500/30 hover:shadow-xl hover:shadow-red-500/50 hover:scale-105",
        outline: "border-[#00f4ff]/50 text-[#00f4ff] bg-transparent backdrop-blur-sm hover:bg-[#00f4ff]/10 hover:border-[#00f4ff] hover:shadow-lg hover:shadow-[#00f4ff]/20",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
